type PlanEditorCalculatedFieldProps = {
  label: string
  value: string
  valueClassName?: string
}

export function PlanEditorCalculatedField({
  label,
  value,
  valueClassName = 'text-emerald-400',
}: PlanEditorCalculatedFieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label
        className="font-medium text-[var(--font-color-label)] uppercase tracking-wider"
        style={{ fontSize: 'var(--font-size-label)' }}
      >
        {label}
      </label>
      <div className="flex min-h-[35px] w-full items-center justify-end rounded-md border border-[var(--glass-border)] bg-[var(--glass-bg)] px-3 py-2 text-[13px] font-bold">
        <span className={valueClassName}>{value}</span>
      </div>
    </div>
  )
}
